import Helping from "../helpers/Helping";
import { MESSAGE, ROLE, ADMIN_USERS, USERS } from '../config/index';
import { API_URL } from '../config/urls';
import { USER_LIST, GET_SETTING } from '../config/routes';
import Service from '../helpers/service';
import { fetchAdminUser, destroyAdminUser } from "../actions/admin_user_action";
import { fetchAdminUserMeta } from "../actions/admin_user_meta_action";
import { getAll as getAllUsers } from "./user.service";
import { trackPromise } from 'react-promise-tracker';
const { ACCESS_CHANGE } = MESSAGE;
let updateCallback = (res) => {

}


export const setAdminUserError = (callback) => {

  updateCallback = callback;

}

export const getAll = (page, limit, search, sorting, sort_type, startDate, endDate, status, isConfirmed, username="", email="", pub_key="") => {
  return dispatch => {
    trackPromise(
      Service.getCall(
        API_URL.ADMIN_API + USER_LIST +
        "?page=" +
        page +
        "&limit=" +
        limit +
        "&search=" +
        search.trim() +
        "&sorting=" +
        sorting +
        "&sort_type=" +
        sort_type +
        "&startDate=" +
        Helping.formatDateInYearMonthDay(startDate) +
        "&endDate=" +
        Helping.formatDateInYearMonthDay(endDate) +
        "&role=admin"+
        "&isEnable=" +
        status +
        "&isConfirmed=" +
        isConfirmed + 
        "&username=" + 
        username + 
        "&email=" + 
        email + 
        "&pub_key=" + 
        pub_key
      )
        .then(response => {
          let total = response.data.payload.total;
          dispatch(fetchAdminUser(response.data.payload.users));
          return dispatch(
            fetchAdminUserMeta({
              page: page,
              limit: limit,
              sorting: sorting,
              sort_type: sort_type,
              start_date: startDate,
              end_date: endDate,
              search: search,
              status: status,
              confirmed: isConfirmed,
              username: username,
              email: email,
              pub_key: pub_key,
              total: total,
              users: response.data.payload.users,
              no_Of_pages: Math.ceil(total / limit)
            })
          );
        })
        .catch(error => {
          console.log(error);

          dispatch(fetchAdminUser([]));
          dispatch(
            fetchAdminUserMeta({
              page: page,
              limit: limit,
              sorting: sorting,
              sort_type: sort_type,
              start_date: startDate,
              end_date: endDate,
              search: search,
              status: status,
              confirmed: isConfirmed,
              username: username,
              email: email,
              pub_key: pub_key,
              no_Of_pages: page,
              total: 0,
              users: 0,
              count: 0
            })
          );
          if (error.response) {
            Helping.redirectToLogin(error);
            return updateCallback({ error_message: error.response.data.message, error_type: 'danger' });
          }
          return updateCallback({
            ...Helping.setNetworkRequestError(error, "fetching admin users")
          })
        })
    )
  };
};


export const updateUserRoles = (data) => {
  const defaultValues = {
    page: 1, limit: data.role.toLowerCase() === ROLE.SUB_ADMIN.toLowerCase() ? ADMIN_USERS.LIMIT : USERS.LIMIT,
    search: "", sorting: "id", sort_type: "DESC", startDate: "", endDate: ""
  }
  return dispatch => {
    Service.postCall(
      API_URL.ADMIN_TRADING_API + GET_SETTING,
      { "action": "make-admin", "user_id": data.user_id, "role": data.role && data.role.toLowerCase() === ROLE.SUB_ADMIN.toLowerCase() ? ROLE.ADMIN.toLowerCase() : ROLE.USER.toLowerCase(), "role_access": data.role_access ? data.role_access : "" })
      .then(response => {
        const { page, limit, search, sorting, sort_type, startDate, endDate } = defaultValues;
        dispatch(getAll(page, limit, search, sorting, sort_type, startDate, endDate, "", ""));
        dispatch(getAllUsers(page, limit, search, sorting, sort_type, startDate, endDate, "", ""));
        return updateCallback({
          error_message: data.type && data.type === ACCESS_CHANGE ? Helping.getMessageString(MESSAGE.ACCESS_CHANGE, data.username ? data.username : "user", data.role.toLowerCase()) : Helping.getMessageString(MESSAGE.ROLE, data.username ? data.username : "user", data.role.toLowerCase()),
          error_type: 'success',
        });
      })
      .catch(error => {
        console.log("error while updating admin role: ", error);
        if (error.response) {
          Helping.redirectToLogin(error);
          return updateCallback({ error_message: error.response.data.message, error_type: 'danger' });
        }
        return updateCallback({
          ...Helping.setNetworkRequestError(error, data.status ? "updating admin" : "reverting admin to user")
        })
      });
  };
}

export const destroy = key => {
  return dispatch => dispatch(destroyAdminUser(key));
}